import { Names } from "@/components/Cashier/OptionsAndAddonAccordion";
import { CashierProduct } from "@/types/CashierProductType";
import { Client } from "@/types/globalTypes";
import { QuantityType } from "@/types/ProductType";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import toast from "react-hot-toast";

export type selectedOptions = number[][];
export type selectedAddons = number[];

export type CartItemType = Pick<
  CashierProduct,
  "_id" | "price" | "nameEN" | "nameAR"
> & {
  quantity: number;
  addons: selectedAddons;
  options: selectedOptions;
  addonsNames: Names[];
  optionsNames: Names[];
  image: string;
  notes?: string;
  maxQuantity: QuantityType;
};

interface CartState {
  cart: CartItemType[];
  customer: Pick<Client, "name" | "phone">;
}

const initialState: CartState = {
  cart: [],
  customer: { name: "", phone: "" },
};

const tableCartSlice = createSlice({
  name: "tableCart",
  initialState,
  reducers: {
    addToTableCart: (state, action: PayloadAction<CartItemType>) => {
      const existingItem = state.cart.find(
        (item) =>
          item._id === action.payload._id &&
          JSON.stringify(item.addons) === JSON.stringify(action.payload.addons) &&
          JSON.stringify(item.options) === JSON.stringify(action.payload.options)
      );

      if (existingItem) {
        if (Number(existingItem.quantity) >= Number(existingItem.maxQuantity)) {
          existingItem.quantity = Number(existingItem.maxQuantity);
          toast.error("هذا هو الحد الاقصى لهذا الصنف");
          return;
        }
        existingItem.quantity += action.payload.quantity;
      } else {
        state.cart.push(action.payload);
      }
    },

    removeFromTableCart: (state, action: PayloadAction<CartItemType>) => {
      state.cart = state.cart.filter(
        (item) =>
          item._id !== action.payload._id ||
          JSON.stringify(item.addons) !== JSON.stringify(action.payload.addons) ||
          JSON.stringify(item.options) !== JSON.stringify(action.payload.options)
      );
    },

    setTableCart: (state, action: PayloadAction<CartItemType[]>) => {
      state.cart = action.payload;
    },

    increaseTableCartQuantity: (state, action: PayloadAction<CartItemType>) => {
      const item = state.cart.find(
        (cartItem) =>
          cartItem._id === action.payload._id &&
          JSON.stringify(cartItem.options) === JSON.stringify(action.payload.options) &&
          JSON.stringify(cartItem.addons) === JSON.stringify(action.payload.addons)
      );
      if (item) {
        item.quantity += 1;
      }
    },

    decreaseTableCartQuantity: (state, action: PayloadAction<CartItemType>) => {
      const item = state.cart.find(
        (cartItem) =>
          cartItem._id === action.payload._id &&
          JSON.stringify(cartItem.options) === JSON.stringify(action.payload.options) &&
          JSON.stringify(cartItem.addons) === JSON.stringify(action.payload.addons)
      );
      if (item && item.quantity > 1) {
        item.quantity -= 1;
      }
    },

    setTableCartCustomer: (
      state,
      action: PayloadAction<{ name: string; phone: string }>
    ) => {
      state.customer = action.payload;
    },

    clearTableCart: (state) => {
      state.cart = [];
      state.customer = { name: "", phone: "" };
    },
  },
});

export const {
  addToTableCart,
  removeFromTableCart,
  setTableCart,
  decreaseTableCartQuantity,
  increaseTableCartQuantity,
  setTableCartCustomer,
  clearTableCart,
} = tableCartSlice.actions;

export default tableCartSlice.reducer;
